<app-base-modal
  [title]="productCompositionsResourceType.name"
  [showStateToggle]="isValid()"
>
  <div class="wrapper">
    <mat-accordion [multi]="true">
      @for (productComposition of productCompositionsData(); track $index) {
        <mat-expansion-panel [expanded]="productComposition.id === 0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="title">
                <div class="title-text">
                  {{ productComposition.compositionTitle }}
                </div>
                @if (!!productComposition.id && isEditModeActive) {
                  <button
                    mat-mini-fab
                    class="btn-delete"
                    (click)="handleDelete($event, productComposition.id, $index)"
                  >
                    <mat-icon class="btn-delete-icon">delete</mat-icon>
                  </button>
                }
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-product-compositions-form
            [parentId]="parentId()"
            [productCompositionData]="productComposition"
            [productCompositionFormGroup]="productCompositionFormGroups()[$index]"
            [noFirstData]="noFirstData()"
            [isEditModeActive]="isEditModeActive"
            (updateProductCompositionData)="updateProductCompositionData($event, $index)"
            (deleteProductComposition)="deleteProductComposition($index)"
          />
          @if (productComposition.id) {
            <div
              app-product-compositions-files
              [productCompositionId]="productComposition.id"
              [isEditModeActive]="isEditModeActive"
              class="product-composition-files"
            ></div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      type="button"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
    <button
      mat-button
      color="primary"
      type="button"
      [disabled]="!isValid()"
      (click)="handleAddNew()"
    >
      Добавить новый
    </button>
  </div>
</app-base-modal>
